import { useCallback } from 'react';
export const useOnMouseOver = ({ behavior, setOpen, }) => {
    const onClick = useCallback(() => {
        if (behavior === 'hover')
            setOpen(true);
    }, [behavior, setOpen]);
    return onClick;
};
